import { Add } from '@wix/wix-ui-icons-common';
import { Button, HoverStyles, PaddingModes } from 'wix-ui-tpa/cssVars';
import React, { useEffect, useRef } from 'react';
import { classes, st } from './FileUpload.st.css';
import { useId } from '../../../../hooks/use-id';
import { useFocusFieldEvent } from '../../../../contexts/events-context';
export const FileUpload = _ref => {
  let {
    fieldId,
    inputId,
    fileInputRef,
    fileUploadButtonRef,
    textBelowButtonRef,
    accept,
    files,
    multiple = false,
    buttonText,
    onChange,
    onFocus,
    onBlur,
    className,
    disabled,
    ariaRoleDescription,
    ariaDescribedBy,
    ariaLabelledBy,
    required
  } = _ref;
  const [checkErrorFocus, setCheckErrorFocus] = React.useState(false);
  const fileHasError = Boolean(files == null ? void 0 : files.find(file => file.state === 'error'));
  const filesExist = files && Boolean(files.length);
  const fileInput = fileInputRef.current;
  const textBellowButton = textBelowButtonRef.current;
  const buttonTextId = useId();
  const buttonTextRef = useRef(null);
  useEffect(() => {
    if (buttonTextRef.current) {
      buttonTextRef.current.id = buttonTextId;
    }
  }, [buttonTextId]);
  const ariaLabelledByIds = [ariaLabelledBy, buttonTextId].filter(Boolean).join(' ');
  const handleFileChange = _files => {
    textBelowButtonRef.current = null;
    onChange == null || onChange(_files);
    setCheckErrorFocus(true);
  };
  const clickHandler = React.useCallback(() => {
    fileInput == null || fileInput.click();
  }, [fileInput]);
  React.useEffect(() => {
    if (checkErrorFocus && filesExist && fileHasError && textBellowButton) {
      textBellowButton.focus();
      setCheckErrorFocus(false);
    }
  }, [checkErrorFocus, filesExist, fileHasError, textBellowButton]);
  useFocusFieldEvent(() => {
    var _fileUploadButtonRef$;
    (_fileUploadButtonRef$ = fileUploadButtonRef.current) == null || _fileUploadButtonRef$.focus();
  }, fieldId);
  return /*#__PURE__*/React.createElement("div", {
    className: st(classes.root, className),
    "data-hook": "file-upload-root"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.mainContainer
  }, /*#__PURE__*/React.createElement("input", {
    className: classes.input,
    ref: fileInputRef,
    type: "file",
    accept: accept,
    onChange: e => handleFileChange(e.currentTarget.files),
    multiple: multiple
  }), /*#__PURE__*/React.createElement(Button, {
    hoverStyle: HoverStyles.underline,
    className: classes.button,
    id: inputId,
    ref: fileUploadButtonRef,
    contentRef: buttonTextRef,
    contentClassName: classes.buttonText,
    paddingMode: PaddingModes.explicitPaddings,
    onClick: clickHandler,
    onFocus: onFocus,
    onBlur: onBlur,
    disabled: disabled,
    prefixIcon: /*#__PURE__*/React.createElement(Add, {
      "aria-hidden": "true"
    }),
    "aria-roledescription": ariaRoleDescription,
    "aria-labelledby": ariaLabelledByIds,
    "aria-describedby": ariaDescribedBy,
    "aria-required": required
  }, buttonText)));
};
FileUpload.displayName = 'FileUpload';
//# sourceMappingURL=FileUpload.js.map